<template>
	<form @submit.prevent="registrar">
		<b-field label="Nombre del rol">
      <b-input icon="account" type="text" placeholder="Ej. Cajero" v-model="nombre" minlength="4" maxlength="50" required></b-input>
    </b-field>
    <b-field label="Permisos del rol">
      <div class="permisos-grid">
        <div v-for="(etiqueta, permiso) in PERMISOS" :key="permiso">
          <b-checkbox v-model="permisos[permiso]">
            {{ etiqueta }}
          </b-checkbox>
        </div>
      </div>
    </b-field>
    <div class="buttons has-text-centered mt-3">
      <b-button type="is-primary" icon-left="check" native-type="submit">Aceptar</b-button>
      <b-button type="is-dark" icon-left="cancel" tag="router-link" to="/roles">Cancelar</b-button>
    </div>
    <errores-component :errores="mensajesError" v-if="mensajesError.length > 0" />
	</form>
</template>
<script>
	import Vue from 'vue'
  import ErroresComponent from '../Extras/ErroresComponent'
  import { PERMISOS } from '@/consts'

	export default {
		name: 'FormRol',
		props: ['rol'],
		components: { ErroresComponent },

		data: () => ({
      nombre: '',
      permisos: {},
			mensajesError: [],
      PERMISOS: {},
		}),

		mounted() {
      this.PERMISOS = PERMISOS

      if (this.rol) {
        this.nombre = this.rol.nombre

        const guardados = { ...(this.rol.permisos || {}) }

        // Claves del catalogo: se respeta lo guardado y, si el rol NO trae la clave, se
        // deja en true. El API solo bloquea cuando la clave vale false, asi que hoy una
        // clave ausente equivale a "permitido": ponerla en false al guardar romperia
        // funciones que estan trabajando (p. ej. el buscador de productos, que es la
        // unica forma de agregar productos al carrito).
        Object.keys(PERMISOS).forEach(permiso => {
          Vue.set(this.permisos, permiso, guardados[permiso] ?? true)
        })

        // Claves que el rol tenga y el catalogo no conozca (permisos viejos, claves
        // retiradas): se conservan tal cual para que guardar el rol no las borre.
        Object.keys(guardados).forEach(permiso => {
          if (!(permiso in this.permisos)) {
            Vue.set(this.permisos, permiso, guardados[permiso])
          }
        })
      } else {
        Object.keys(PERMISOS).forEach(permiso => {
          Vue.set(this.permisos, permiso, true)
        })
      }
		},

		methods: {
			registrar() {
				this.$emit('registrar', { nombre: this.nombre, permisos: JSON.stringify(this.permisos) })

				this.nombre = ''
        this.permisos = {}
			}
		},
	}
</script>

<style scoped>
.permisos-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
}
</style>
